import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: '100%',
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      height: `unset`,
      minHeight: 360,
      overflow: 'unset',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  emoji: {
    fontSize: 24,
    marginRight: theme.spacing(1),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
      justifyContent: 'center',
    },
  },
  description: {
    fontColor: theme.palette.colors.darkBlue,
    fontWeight: 700,
    [theme.breakpoints.up('mobile')]: {
      textAlign: 'center',
    },
  },
  additionalDescription: {
    [theme.breakpoints.up('mobile')]: {
      textAlign: 'center',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/components/Survey/useStyles.js